/** @typedef {'rollup' | 'estimated'} DurationPrefixKind */

/**
 * @param {boolean} isRollup
 * @param {boolean} showPrefix
 * @returns {DurationPrefixKind | null}
 */
export function getDurationPrefixKind(isRollup, showPrefix) {
  if (showPrefix) {
    return isRollup ? 'rollup' : 'estimated';
  }
  return isRollup ? 'rollup' : null;
}

/**
 * @param {DurationPrefixKind | null} kind
 */
export function getDurationPrefixGlyph(kind) {
  if (kind === 'rollup') return '∑ ';
  if (kind === 'estimated') return '-';
  return '';
}

/**
 * @param {boolean} isRollup
 * @param {boolean} showPrefix
 */
export function buildDurationPrefix(isRollup, showPrefix) {
  return getDurationPrefixGlyph(getDurationPrefixKind(isRollup, showPrefix));
}
